import React from 'react';

const OrderActionToken = ({ action }) => {
	const buy = (action === "buy" || action === "Buy" || action === "BUY");
	const sell = (action === "sell" || action === "Sell" || action === "SELL");

	return <span className={`colour-text-${buy ? "positive" : sell ? "danger" : "black"} text-transform-uppercase`}>{action}</span>;
}

export default OrderActionToken;